import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/ycx/home_phone.png'


const _withScopeId = n => (_pushScopeId("data-v-11c8372e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = { style: {"display":"flex","margin-left":"-6px"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "filling-div-box" }
const _hoisted_5 = {
  key: 0,
  class: "filling-mask"
}
const _hoisted_6 = {
  key: 1,
  class: "filling-div"
}
const _hoisted_7 = { class: "footer-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem","font-weight":"bold"} }, "免费咨询电话"),
  /*#__PURE__*/_createElementVNode("div", { style: {"color":"#165fd8","font-weight":"bold"} }, "189-2528-7266")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right-mask" }),
  /*#__PURE__*/_createElementVNode("div", { class: "right-item" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "电话咨询")
  ])
], -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'Indicator',
  props: ["courserIndex", "codeNumber"],
  emits: ["setActiveItem"],
  setup(__props, { emit: $emit }) {

const props = __props




const goToSlide = (index: number) => {
  $emit("setActiveItem", index);
};

const goWayToLink = () => {
  // window.location.href = "https://work.weixin.qq.com/kfid/kfc2f57dba70b949766";
};

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.codeNumber, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["custom-indicator-item", { active: index === __props.courserIndex }]),
          key: index,
          onClick: ($event: any) => (goToSlide(index))
        }, [
          _createElementVNode("div", null, _toDisplayString(`0` + Number(index + 1)), 1),
          _createElementVNode("div", _hoisted_4, [
            (index === __props.courserIndex)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : _createCommentVNode("", true),
            (index === __props.courserIndex)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_popover, {
        placement: "top-start",
        width: "180",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}
}

})